export enum PaymentType {
  CARD = 'CARD',
  CASH = 'CASH',
}
